import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';

import Landing from '../Landing';

const Tweet = () => {
  const {
    accountName,
    owner: { link },
  } = useLandingContext();

  return (
    <Landing
      title={__('tweeted').i__({
        url: link,
        account: accountName,
      })}
    />
  );
};

export default Tweet;
